import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatTitleCaseWords } from 'src/app/shared/utils/text-formatting';

@Component({
  selector: 'tags-show-more',
  templateUrl: './tags-show-more.component.html',
  styleUrls: ['./tags-show-more.component.scss']
})
export class TagsShowMoreComponent implements OnInit {

  showAllRemove = false;

  constructor(
    public dialogRef: MatDialogRef<TagsShowMoreComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data?.showAllRemove){
      this.showAllRemove = true;
    }
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  removeItemFromArray(item: any, arrayName: string) {
    const newArray = this.data[arrayName].filter((element) => element !== item);
    this.data[arrayName] = newArray;
    this.detectChanges();
  }

  removeAllItemsFromArray(arrayName: string) {
    this.data[arrayName] = [];
    this.detectChanges();
  }

  detectChanges(): void {
    this.cdr.detectChanges();
  }

  displayTitleCaseWords(value: string | null | undefined): string {
    return formatTitleCaseWords(value);
  }
}
